import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProjectService } from '../services/project.service';
import { StrategyService } from '../services/strategy.service';
import { forkJoin, map, Observable, switchMap, catchError, of, tap, take } from 'rxjs';


export const listProjectResolver: ResolveFn<Observable<any>> = (route, state) => {
  const projectService = inject(ProjectService);
  const strategyService = inject(StrategyService);

  const strategyId = route.params['strategyId'];
  
  if (!+strategyId) {
    return strategyService.defaultStrategy$.pipe(
      tap(strategy => console.log('Default strategy:', strategy)),
      switchMap((strategy: any) => {
        if (!strategy || !strategy.id) {
          console.error('No default strategy found');
          return of({ 
            projects: { data: { projects: [], pagination: { page: 1, page_size: 20, total_records: 0, total_pages: 0, no_records: 0 } } }, 
            strategies: [], 
            strategy: null 
          });
        }
        
        console.log('Loading projects for strategy ID:', strategy.id);
        
        return forkJoin({
          projects: projectService.getListPaginatedProjects(strategy.id, { page: 1, page_size: 20, scope: 'all' }).pipe(
            tap(p => console.log('Projects API response:', p)),
            catchError(err => {
              console.error('Error in projects call:', err);
              return of({ data: { projects: [], pagination: { page: 1, page_size: 20, total_records: 0, total_pages: 0, no_records: 0 } } });
            }),
            take(1)
          ),
          strategies: strategyService.RawStrategies$.pipe(
            tap(s => console.log('RawStrategies count:', s?.length)),
            catchError(err => {
              console.error('Error in strategies call:', err);
              return of([]);
            }),
            take(1)
          )
        }).pipe(
          map(({ projects, strategies }) => {
            const result = { projects, strategies, strategy };
            console.log('Final resolver result:', result);
            return result;
          })
        );
      }),
      catchError(error => {
        console.error('Outer error in resolver:', error);
        return of({ 
          projects: { data: { projects: [], pagination: { page: 1, page_size: 20, total_records: 0, total_pages: 0, no_records: 0 } } }, 
          strategies: [], 
          strategy: null 
        });
      })
    );
  } else {
    return strategyService.getStrategyById(strategyId).pipe(
      tap(strategy => console.log('Strategy loaded:', strategy)),
      switchMap((strategy: any) => {
        console.log('Loading projects for strategy ID:', strategyId);
        
        return forkJoin({
          projects: projectService.getListPaginatedProjects(strategyId, { page: 1, page_size: 20, scope: 'all' }).pipe(
            tap(p => console.log('Projects API response:', p)),
            catchError(err => {
              console.error('Error in projects call:', err);
              return of({ data: { projects: [], pagination: { page: 1, page_size: 20, total_records: 0, total_pages: 0, no_records: 0 } } });
            }),
            take(1)
          ),
          strategies: strategyService.RawStrategies$.pipe(
            tap(s => console.log('RawStrategies count:', s?.length)),
            catchError(err => {
              console.error('Error in strategies call:', err);
              return of([]);
            }),
            take(1)
          )
        }).pipe(
          map(({ projects, strategies }) => {
            const result = { projects, strategies, strategy };
            console.log('Final resolver result:', result);
            return result;
          })
        );
      }),
      catchError(error => {
        console.error('Outer error in resolver:', error);
        return of({ 
          projects: { data: { projects: [], pagination: { page: 1, page_size: 20, total_records: 0, total_pages: 0, no_records: 0 } } }, 
          strategies: [], 
          strategy: null 
        });
      })
    );
  }
};
